// Google Auth Constants
export const GOOGLE_AUTH_REQUEST = 'GOOGLE_AUTH_REQUEST';
export const GOOGLE_AUTH_SUCCESS = 'GOOGLE_AUTH_SUCCESS';
export const GOOGLE_AUTH_FAIL = 'GOOGLE_AUTH_FAIL';

// GitHub Auth Constants
export const GITHUB_AUTH_REQUEST = 'GITHUB_AUTH_REQUEST';
export const GITHUB_AUTH_SUCCESS = 'GITHUB_AUTH_SUCCESS';
export const GITHUB_AUTH_FAIL = 'GITHUB_AUTH_FAIL';